import Vue from 'vue'
import configs from '@/config'

let resource = null

export const actions = {
  verifyEmail: {
    method: 'POST',
    url: `${configs.baseUrl}/api/email-verification/verify`,
  },
  resendVerification: {
    method: 'POST',
    url: `${configs.baseUrl}/api/email-verification/resend`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// Public verify-email page: posts the raw token extracted from the email link.
// Returns the backend payload: { verified: true } on success, or
// { verified: false, reason } on failure (invalid/expired/superseded token).
const verifyEmail = async (token) => {
  const res = await resource.verifyEmail({}, { token })
  return res.body
}

// Re-issue a verification email for the authenticated user (uses req.user on
// the backend; no body needed). Returns { sent: true } or
// { sent: false, alreadyVerified: true }; throws 429 when rate-limited.
const resendVerification = async () => {
  const res = await resource.resendVerification({}, {})
  return res.body
}

export default {
  initResource,
  verifyEmail,
  resendVerification,
}
